"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverLicenceSelect = void 0;
var DriverLicenceSelect_1 = require("./DriverLicenceSelect");
Object.defineProperty(exports, "DriverLicenceSelect", { enumerable: true, get: function () { return DriverLicenceSelect_1.DriverLicenceSelect; } });
